export enum REFERRAL_QUERY_PARAM_KEYS {
  CUSTOMER_ID_PARAM = 'CustomerID',
  OPPORTUNITY_ID_PARAM = 'OpportunityID',
  CRM_OPPORTUNITY_ID_PARAM = 'crmOpportunityID',
  REFERRAL_ID_PARAM = 'ReferralID',
  DOCUMENT_LINK = 'documentLink'
}

export enum STATELESS_SESSION_PARAM_KEYS {
  ZIP_CODE = 'zipCode',
  COUNTY = 'county',
  PLAN_ID = 'planId',
  PLAN_YEAR = 'planYear',
  REDIRECT_URL = 'redirectUrl'
}

export enum GLOBAL_DATA_PARAM_KEYS {
  ZIP_CODE = 'preloadZipCode',
  COUNTY = 'preloadCounty'
}